import React from 'react'
import { Box } from '@material-ui/core'
import * as icons from '~/assets/icons'
import { DocumentIcon } from '~/assets/icons'
import { mutualTheme } from '~/utils/theme'
import { RequiredDocument } from '~/utils/documents'
import { AccordionActions, AccordionInfo, AccordionInfoContainer } from './components'

type Icon = keyof typeof icons

type NextStepsType = {
  title: string,
  description: string,
  icon: Icon
}[]

type AccordionsContainerProps = {
  requiredDocuments: RequiredDocument[]
}

const nextSteps: NextStepsType = [
  {
    icon: 'PinIcon',
    title: 'Endereço comercial',
    description: 'Informe o endereço comercial da sua empresa'
  },
  {
    icon: 'AtIcon',
    title: 'Redes Sociais',
    description: 'Mostre a presença online da sua empresa (opcional)'
  },
  {
    icon: 'EmailIcon',
    title: 'Validação de e-mail',
    description: 'Valide o email cadastrado'
  },
  {
    icon: 'DeviceIcon',
    title: 'Validação de telefone',
    description: 'Valide o telefone cadastrado'
  }
]

export const AccordionsContainer: React.FC<AccordionsContainerProps> = ({ requiredDocuments }) => {
  const nextStepsList = nextSteps.map(step => {
    const Icon = icons[step.icon]
    return (
      <AccordionInfo
        key={step.title}
        icon={<Icon htmlColor={mutualTheme.palette.textGray3.main} />}
        title={step.title}
        description={step.description}
      />
    )
  })

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 3
    }}>
      <AccordionActions title='Complete os seus dados'>
        <AccordionInfoContainer>
          {nextStepsList}
        </AccordionInfoContainer>
      </AccordionActions>

      <AccordionActions title='Envie a Documentação necessária'>
        <AccordionInfoContainer>
          {requiredDocuments.map((document) => (
            <AccordionInfo
              key={document.title}
              icon={<DocumentIcon htmlColor={mutualTheme.palette.textGray3.main} />}
              title={document.title}
              description={document.description}
            />
          ))}
        </AccordionInfoContainer>
      </AccordionActions>
    </Box>
  )
}
